import {ReactNode, ReactElement} from 'react';

import {UIState} from 'coreStore/data/ui/types';
import {ICategory} from 'coreStore/data/categories/types';

import type {INavigationParent} from 'coreHooks';

export enum ENavigationItemViewAll {
	'None' = 'none',
	'Show on Large Screens' = '>=xx-large',
	'Show on Small Screens' = '<xx-large',
	'Show on All Screens' = 'all',
}

export interface INavigationItemProps {
	id?: string;
	title?: string;
	color?: string;
	url?: string;
	viewAll?: {
		url: string;
		show: ENavigationItemViewAll;
	};
	category?: string;
	editorialContent?: ReactNode;
	image?: ReactNode;
	imageTitle?: string;
	customSettings?: {
		showEditorialContent?: boolean;
		showImage?: boolean;
	};
	template?: ReactNode;
	children?: ReactNode;
	isActive?: boolean;
	hasActive?: boolean;
	hasSubLists?: boolean;
	navigationStack?: UIState['navigationStack'];
	handleNavigationItemClick?: () => void;
	animationClasses?: string;
	parent?: INavigationParent;
	isInHeaderContext?: boolean;
	description?: string;
	isFlatSubList?: boolean;
	navigationParams?: any;
	queryParameters?: string;
	requiresLogin?: boolean;
}

export interface INavigationItemOldProps {
	category?: {
		items: Array<ICategory>;
		type: string;
	};
	title?: string;
	color?: string;
	viewAll?: ENavigationItemViewAll;
	targetPage?: ReactElement;
	targetUrl?: string;
	children?: ReactNode[];
	apiCategory?: any;
	subItemsCollection?: {
		items: INavigationItemOldProps[];
	};
	subItems?: {props: any; total: number};
	sys: {
		id: string;
	};
	template: ReactNode;
	parent?: INavigationParent;
	description?: string;
	isFlatSubList?: boolean;
	navigationParams?: any;
	queryParameters?: Record<string, string>;
	sorting?: string;
	customSettings?: Record<string, any>;
	editorialContent?: any;
	requiresLogin?: boolean;
	image?: any;
	media?: any;
	imageTitle?: string;
}

export enum ENavigationItemsSortingOrder {
	ASCEND = 'A-Z',
	DESCEND = 'Z-A',
	NONE = 'none',
}
